/**
 * Radix dialogs render through portals, so a secondary dialog opened from
 * inside a form dialog (e.g. an attach-document picker) is a SIBLING in the
 * DOM, not a child. Clicks inside the secondary dialog therefore register as
 * "outside interactions" on the underlying form dialog and would silently
 * dismiss it, discarding unsaved work (see the Vboard editor fix in
 * pages/vboard.tsx).
 *
 * Pass this to `onInteractOutside` on the underlying form dialog's
 * DialogContent: it blocks dismissal when the interaction happened inside
 * another dialog/alert-dialog/popper layer, while still allowing genuine
 * outside clicks (on the overlay/backdrop) to close the dialog as usual.
 */
export function preventDismissFromSiblingDialog(e: {
  target: EventTarget | null;
  preventDefault: () => void;
}) {
  const target = e.target;
  if (
    target instanceof Element &&
    target.closest(
      '[role="dialog"], [role="alertdialog"], [data-radix-popper-content-wrapper]',
    )
  ) {
    e.preventDefault();
  }
}
